import { call, put, takeEvery } from 'redux-saga/effects';
import { utils as commonUtils } from '@febos-io/common';
import { utils as designUtils } from '@febos-io/design';
import { HANDLE_SIGN_IN, HANDLE_SIGN_IN_ERROR } from './types';
import { setLoading, setUserInfo, setUserSession } from './actions';
import { parseSesion, t } from '../utils';
import { getPersonSetting, USER_LOADING } from '../config';

const { Auth } = commonUtils;

function* handleSignIn({
  payload: {
    user,
    isFederated = false,
    config: { singlePathname, navigate, isExternalAuth, ...props},
  },
}) {
  try {
    yield put(setLoading(true));

    const currentUserInformation = yield call(() => Auth.currentUserInfo());
    const userSessionData = {
      ...currentUserInformation,
      ...user,
      isFederated,
    };
    console.log('saga.handleSignIn', user, userSessionData, props);
    yield put(setUserSession(parseSesion(userSessionData)));
    const request = new commonUtils.Request();

    if (isExternalAuth) {
      const { info, } = yield call(() => request.exec(getPersonSetting()));

      yield put(setUserInfo(info));
      localStorage.setItem('user-id', info.id);

      navigate(singlePathname);
      yield put(setLoading(false));
      navigate(singlePathname);
      return;
    }
    navigate(USER_LOADING);
    yield put(setLoading(false));
  } catch (error) {
    yield put(setLoading(false));
    yield call(() => commonUtils.errorHandler(error));
  }
}

function * handleSignInError(
  {
    payload: {
      event,
    },
  }
) {
  try {
    yield put(setLoading(false));
    if (event.data.message === 'PreSignUp+failed+with+error+USER_NOT_FOUND.+') {
      designUtils.error(t('Invalid credentials'));
    } else {
      designUtils.error(t(event.data.message));
    }
  } catch (error) {
    yield put(setLoading(false));
    yield call(() => commonUtils.errorHandler(error));
  }
}

export const sagas = [
  takeEvery(HANDLE_SIGN_IN, handleSignIn),
  takeEvery(HANDLE_SIGN_IN_ERROR, handleSignInError)
];

export default sagas;
